import styled                 from 'styled-components';

import { CloseVector        } from 'src/components/vector/close';

import { DialogVariants     } from 'src/components/common/dialog';
import { ButtonVariants     } from 'src/components/common/button';
import { RadioGroupVariants } from 'src/components/common/radio-group';
import { IconButtonVariants } from 'src/components/common/icon-button';

import { cssFlexColumn,
         cssFlexRow,
         Typo,
         themeTypos,
         typoAsCSS,
         themeColors        } from 'src/providers/theme/shared';



type SelectDefectTypeDialogLookAndFeel = {
  paddings: number[];

  captionHeight: number;
  captionTypo: Typo;
  captionColor: string;
  captionPaddingLeft: number;

  gap: number;

  buttonVariant: ButtonVariants;
  dialogVariant: DialogVariants;
  closeButtonVariant: IconButtonVariants;
  radioVariant: RadioGroupVariants;
}

const selectdefecttypedialog_light: SelectDefectTypeDialogLookAndFeel = {
  paddings: [28, 20],

  captionHeight: 48,
  captionTypo: themeTypos.GRTSKREG_W600_S18_LH24,
  captionColor: themeColors.PrimaryBlack,
  captionPaddingLeft: 24,

  gap: 24,

  buttonVariant: 'h48bluefill',
  dialogVariant: 'light',
  closeButtonVariant: 's48bluered',
  radioVariant: 'light',
}

export type SelectDefectTypeDialogVariants = 'light';

export const selectdefecttypedialog_variants: Map<SelectDefectTypeDialogVariants, SelectDefectTypeDialogLookAndFeel> = 
  new Map<SelectDefectTypeDialogVariants, SelectDefectTypeDialogLookAndFeel>([
    ['light', selectdefecttypedialog_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: SelectDefectTypeDialogLookAndFeel
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.gap}px;
  position: relative;

  padding: ${(args) => args.lookAndFeel.paddings[0]}px ${(args) => args.lookAndFeel.paddings[1]}px;
  padding-top: 0;
`

export const CaptionContainer = styled.div<{
  lookAndFeel: SelectDefectTypeDialogLookAndFeel
}>`
  ${cssFlexRow};
  align-items: center;
  height: ${(args) => args.lookAndFeel.captionHeight}px;
  position: relative;
`

export const Caption = styled.div<{
  lookAndFeel: SelectDefectTypeDialogLookAndFeel
}>`
  flex-grow: 2;
  text-align: center;

  padding-left: ${(args) => args.lookAndFeel.captionPaddingLeft}px;

  ${(args) => typoAsCSS(args.lookAndFeel.captionTypo)};
  color: ${(args) => args.lookAndFeel.captionColor};
`

export const Close = styled.div<{
  lookAndFeel: SelectDefectTypeDialogLookAndFeel
}>`
  position: relative;
  right: -${(args) => args.lookAndFeel.paddings[1]}px;
`

export const CloseOutlineVectorBig = styled(CloseVector)`
  width: 16px;
  height: 16px;
`;
